/* eslint-disable no-restricted-globals */
/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { get } from 'lodash';
import moment from 'moment';
import { getRangeFromDates, isToday, TODAY } from '../../../utils/dates';
import DatesRangePicker from './DateRangePicker';
import {
  MAX_DATE,
  MAX_DATE_FUTURE,
  MIN_DATE
} from '../../../config/filterOptions';
import './styles/Toggle.css';

const cvmiPath = path => location.pathname.toLowerCase().includes(path);
const MAX_DATE_SWITCH = cvmiPath('/anticipation-tracker')
  ? MAX_DATE_FUTURE
  : MAX_DATE;

const DEFAULT_RANGE = `${MIN_DATE} to ${MAX_DATE_SWITCH}`;

const toggleTooltip = tooltipMessage => (
  <Tooltip id="data-bar__item-tooltip">{tooltipMessage}</Tooltip>
);

const Toggle = ({
  id,
  value,
  options,
  onChange,
  tooltip,
  isDate,
  isDisabled,
  alwaysShowDivider
}) => {
  const [selection, setSelection] = useState(null);
  const [datesRange, setDatesRange] = useState(DEFAULT_RANGE);
  const [dateFocus, setDateFocus] = useState(null);

  const handleValue = () => {
    if (!value) {
      setSelection(options[0].value);
    } else if (typeof value === 'string') {
      setSelection(value);
    } else if (typeof value[0] === 'string') {
      setSelection(value[0]);
    } else if (value[0] && typeof value[0] === 'object') {
      setSelection(value[0].value);
    } else if (typeof value === 'object') {
      setSelection(value.value);
    }
  };

  useEffect(() => {
    handleValue();
  }, []);

  useEffect(() => {
    if (value && isDate) {
      setDatesRange(value.value ? value.value : DEFAULT_RANGE);
      if (!options.filter(o => o.value === value.value).length) {
        setSelection(-1);
      }
    }

    handleValue();
  }, [value]);

  const onSelect = option => e => {
    if (isDisabled) {
      return null;
    }
    setSelection(e.target.value);

    if (isDate && option.id !== 'custom-date') {
      setDateFocus(null);
      setDatesRange(e.target.value);
    }

    if (isDate && option.id === 'custom-date') {
      setDateFocus('startDate');
      setDatesRange(`${moment(TODAY)} to ${MAX_DATE_SWITCH}`);
      return;
    }
    onChange(id, option);
  };

  const onCustomRangeSelected = dates => {
    const realEndDate = isToday(dates.endDate)
      ? dates.endDate
      : moment(dates.endDate).add(1, 'day');

    const range = getRangeFromDates({
      startDate: dates.startDate,
      endDate: realEndDate
    });

    const dayBeforeEndDate = moment(realEndDate).subtract(1, 'day');
    range.label = getRangeFromDates({
      startDate: dates.startDate,
      endDate: dayBeforeEndDate
    }).label;

    onChange(id, { ...range, id: 'custom-date' });
  };

  const isSelected = option =>
    selection == option.value ||
    (!selection && !option.value) ||
    get(value, 'id', '') === option.id;

  const shouldShowDivider = index => {
    if (alwaysShowDivider) {
      return true;
    }
    if (index === 0) {
      return false;
    }
    if (isSelected(options[index])) {
      return false;
    }
    if (isSelected(options[index - 1])) {
      return false;
    }

    return true;
  };

  return (
    <>
      <div
        className={`tvt-filter__exterior-toggle ${
          isDisabled ? 'is-disabled' : ''
        }`}
      >
        {options.map((opt, i) => (
          <>
            {i !== 0 && (
              <div className="tvt-filter__toggle-divider">
                {shouldShowDivider(i) && '|'}
              </div>
            )}

            <button
              className={isSelected(opt) ? 'selected' : ''}
              value={opt.value}
              onClick={onSelect(opt)}
            >
              {opt.label}
            </button>
          </>
        ))}
      </div>
      {tooltip && (
        <OverlayTrigger placement="bottom" overlay={toggleTooltip(tooltip)}>
          <i className="page-header__title-tooltip fa fa-info-circle" />
        </OverlayTrigger>
      )}
      {isDate && (
        <div className="toggle-dates-selected__wrapper">
          <div className="toggle-dates-selected__label">Dates Selected:</div>
          <DatesRangePicker
            onDatesChange={onCustomRangeSelected}
            datesRange={datesRange}
            minDate={MIN_DATE}
            maxDate={MAX_DATE_SWITCH}
            focus={dateFocus}
            isDisabled={isDisabled}
          />
        </div>
      )}
    </>
  );
};

Toggle.propTypes = {
  options: PropTypes.shape([]),
  onChange: PropTypes.func,
  tooltip: PropTypes.string,
  id: PropTypes.string.isRequired,
  isDate: PropTypes.bool,
  isDisabled: PropTypes.bool,
  alwaysShowDivider: PropTypes.bool,
  value: PropTypes.oneOf([
    PropTypes.shape([
      {
        value: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired
      }
    ]),
    PropTypes.array
  ])
};

Toggle.defaultProps = {
  options: [],
  onChange: () => {},
  tooltip: '',
  value: null,
  isDate: false,
  isDisabled: false,
  alwaysShowDivider: false
};

export default Toggle;
